import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import rootReducer from './rootReducer'
import getInitialState from './getInitialState'

const preloadedState = getInitialState()

// We could probably remove this and just return an empty array of middleware in configureStore(),
// but let's keep it as a reference on clean syntax to add new middleware
function getMiddleWare() {
	const middleware = [
		...getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}),
	]

	/*
	 * Add new middleware here if needed.
	 * eg. middleware.push(<newMiddleware>)
	 * */

	return middleware
}

const store = configureStore({
	reducer: rootReducer,
	enhancers: [],
	preloadedState,
	middleware: getMiddleWare(),
})

// If we don't place the redux store initially on the window, and prioritize the export of that store,
// it will not behave like a singleton when imported from multiple files.
// We use special naming a'la "__NAMING_CONVENTION__" to prevent global namespace pollution/collisions.
window.__REDUX_STORE_INSTANCE__ = window.__REDUX_STORE_INSTANCE__ || store

// Subscribe to state update and set localStorage for every update.
// This way we can prevent many unnecessary requests.
// store.subscribe(_ => {
//     const state = store.getState()
//     const json = JSON.stringify(state)

//     localStorage.setItem('__REDUX_STATE__', json);
// })

export default window.__REDUX_STORE_INSTANCE__
